export const COMPANY_ID_KEY = 'te-comp-id';
export const APP_AREA_KEY = 'te-app-area';
export const REDIRECT_URL_KEY = 'te-redirect-url';
export const DASHBOARD_ID_KEY_PREFIX = 'te-dashboard-id';

export const ALL_STATE_KEYS = [COMPANY_ID_KEY, APP_AREA_KEY];
